import $ from 'jquery';
import { closeModal } from '@/function/function.js';
import { openMenu, closeMenu, open_menu_state, convertDateToDdMmYyyy } from '@/function/function.js';
import { cca_config } from '@/config';

export default {
    name: 'factures-en-attente',
    components: {},
    props: ["passedConsult"],
    data() {
        return {
            user_role: 0,
            compte_id: 0,
            user_id: 0,
            date_facture: '',

            today_date: this.date_function(),
            ref_bon: '',
            display_all_loading: true,
            save_loading: false,
            loadingAnalyse: false,
            loadingExamen: false,
            is_savable: true,
            is_printable: false,
            idUser: 1,
            vm_state: open_menu_state,
            operation_saved: null,
            all_soins: null,
            soins: [],
            box1: 0,
            box2: 1,
            box3: 1,
            operation_selected: null,
            somme_encaisse: 0,
            total_analyse_restant: 0,
            analyse_to_pay_id: 0,
            analyse_to_pay_montant: 0,
            carnets: [],
            
            index_medicament_selected: null,

            // Determine s'il y a eu un paiement déjà effectué
            is_paid_before: false, //  Mettre à false par defaut
            analyse_checked: [],
            prescription_checked: [],
            consult_back: null,

            examen_checked: [],
            total_prix_examen: 0,
            examen_to_pay_id: 0,
            examen_to_pay_montant: 0,
            has_examen: null,

            btn_disable: false,

            total_assureur: {
                consultation: 0,
                analyse: 0,
                examen_para: 0,
                protocoles: 0,
                ordonnance: 0,
            },

            total_assure: {
                consultation: 0,
                analyse: 0,
                examen_para: 0,
                protocoles: 0,
                ordonnance: 0,
            },

            // Info prescriptions
            total_prix_medicaments: 0,
            qte_medoc: [],
            
            prix_base_loading: true,
            is_ordonnance: false,
            
            is_soins: false,
            is_analyse: false,
            is_examen: false,
            is_consultation: false,

            /**
             * Total prix des injectables
             * @type int
             */
            prix_injectables: 0,
            p_assure: [],
            p_tot_assure: [],

            // Info analyse
            p_alys_assure: [],

            // Info examen
            p_exm_assure: [],

            // Ordonnance info
            p_ord_assure: [],

            is_coupon: false,
            coupon: '',
            prix_a_payer: 0,
            calc_prix_reduction: 0,

            filter_bill: [
                {
                    id: 1,
                    libelle: 'Filtrer'
                },
                {
                    id: 2,
                    libelle: 'Payée'
                },
                {
                    id: 3,
                    libelle: 'Différée'
                }
            ],
            chosen_filter: {
                id: 1,
                libelle: 'Filtrer'
            },
            prix_consult: [],
            consultation_paye: 0,
            base_coupon: 0,                     // Montant sur lequel le coupon doit être appliqué
            is_consultation_coupon: false,
            coupon_too_big: false,
            can_pay_with_deposit: false,
            depot_info: {},
            deposit_is_less: false,
            is_depot: false,

            is_reliquat: true,
            can_apply_reliquat: false,
            espece_is_less: false,
            reliquat_is_greater: false,
            field_is_empty: false,

            paiement: {
                user_id: 0,
                patient_id: 0,
                prestation: "",
                montant_du: 0,
                montant_recu: 0,
                reliquat: 0,
                reliquat_remis: 0,
                reste_a_payer: 0,
                montant_net_paye: 0,
                compte_id: 0,
                remise: 0,
            },
        }
    },

    watch: {
        coupon() {
            this.coupon_too_big = false
            this.calcReduction()
        },

        chosen_filter() {
            if (this.chosen_filter.id == 2) {
                this.$router.push({ path: '/consultations-all/factures/'+this.passedConsult });
            } else if (this.chosen_filter.id == 3) {
                this.$router.push({ path: '/consultations-all/factures-differees/'+this.passedConsult });
            }
        }
    },

    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        patient() {
            return (this.consultation) ? this.consultation.patient : null
        },

        patient_est_assure() {
            return this.$store.getters['patient_est_assure'];
        },

        info_assurance() {
            return this.$store.getters['info_assurance'];
        },

        groupe_assur_actif() {
            return this.$store.getters['groupe_assur_actif'];
        },

        consultation() {
            return this.consult_back
        },
        analyses() {
            return this.$store.getters["analyses_for_consult"]
        },

        demande_examen_consultation() {
            return this.$store.getters["demande_examen_consultation"]
        },
        
        bulletin_id() {
            return this.$store.getters["analyses_for_consult"].id
        },

        prescription() {
            return this.$store.getters["prescriptions_pharmacie"]
        },

        prix_carnet() {
            let total = 0;
            this.carnets.forEach((el) => {
                if (el.libelle == 'Apport social') {
                    total -= parseInt(el.montant)
                } else {
                    total += parseInt(el.montant)
                }
            });

            return total;
        },
        
        total_prescription_restant() {
            let total = 0;
            if (this.prescription) {
                this.prescription.forEach((data) => {

                    // calculer le prix
                    let prix = 0
                    prix = parseInt((parseInt(data.quantite) - parseInt(data.quantite_achat)) * parseInt(data.prix))
                    total += prix;

                })
            }
            return parseInt(total);
        },
        
        total_analyse() {
            let total = 0;
            // this.total_analyse_restant = 0;
            if (this.analyses) {
                if (this.analyses.length > 0) {
                    this.analyses.forEach(data => {
                        let prix_analyse = 0
                        prix_analyse = (this.patient_est_assure == 0)?parseInt(data.analyse.prix):parseInt(data.analyse.base_assurance)
                        total += prix_analyse;
                    })
                }
            }
            return parseInt(total);
        },

        // Total Admission
        total_admission() {
            let total = 0

            this.soins.admissions.forEach(data => {
                total += data.total
            })

            return total
        },

        total_soins() {
            if (this.soins)
                return parseInt(
                    this.total_admission + this.soins.acte_total + this.soins.consommable_total + this.soins.injectable_total
                )
            else
                return 0
        },

        total_analyse_assure() {
            return parseInt(this.total_analyse)
        },

        // total_examen() {
        //     let total = 0
        //     this.demande_examen_consultation.forEach(element => {
        //         total += parseInt(element.type_examen_prix)
        //     });
        //     this.total_prix_examen = total
            
        //     return total
        // },

        total() {
            let sum = 0
            if (this.consultation) {
                if (
                    this.consultation_paye > 0 || this.total_analyse_restant >= 0 || this.total_prix_examen >= 0 || 
                    (this.soins.acte_total >= 0 || this.soins.consommable_total >= 0 || this.soins.injectable_total >= 0) || 
                    this.total_prix_medicaments >= 0
                ) {
                    sum = this.consultation_paye + this.total_analyse_restant + this.total_prix_examen + this.soins.acte_total + 
                        this.soins.consommable_total + this.soins.injectable_total + this.total_prix_medicaments

                    this.display_all_loading = false;
                }
            }

            return sum
        },

        total_paye_assureur() {
            let total = 0
            total = (this.total_assureur.analyse) + (this.total_assureur.examen_para) + (this.total_assureur.protocoles) +
                    (this.total_assureur.ordonnance) + this.total_assureur.consultation

            return total;
        },

        total_paye_assure() {
            let total = 0
            total = (this.total_assure.analyse) + (this.total_assure.examen_para) + (this.total_assure.protocoles) + 
                    (this.total_assure.ordonnance) + this.total_assure.consultation

            return total;
        },

        /**
         * Recupère l'ID des jours programmés pour les conduites à tenir
         * @returns 
         */
        jourCats() {
            return this.$store.getters['jour_cats'];
        },

        prix_base_assur() {
            return this.$store.getters['prix_base_assur'];
        },

        canSeeFactureDiffere() {
            let facteur = false
            if(
                this.is_ordonnance == false && this.is_soins == false && this.is_analyse == 0 && 
                this.is_examen == 0 && this.is_consultation == false
            ) {
                facteur = false
            } else {
                facteur = true
            }

            return facteur
        },

        tarif() {
            return this.$store.getters['tarifConsultation']
        },

        depot_patient() {
            return this.$store.getters['depot_patient'];
        },
    },

    async mounted() {
        this.$store.dispatch('getGroupeAssuranceActif')

        this.date_facture = convertDateToDdMmYyyy.convertDate(new Date());

        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1 //  Caisse principale
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4 //  Caisse 1 (Infirmier)
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3 //  Comptabilité
            }
        }

        // >>>> Etat d'ouverture d'une caisse
        this.$store.dispatch('getStatutOuvertureCaisse', this.compte_id).then((response) => {
            if (response == 1) {
                this.$router.push({ path: '/clinicaa/comptabilite/caisse' })
            }
        });

        this.$store.dispatch('getTypesForConsultation', this.passedConsult).then((response) => {

            this.consult_back = response

            // Verifie si le patient est assuré
            this.$store.dispatch('checkIfPatientEstAssure', response.patient_id)

            // Info Assurance
            this.$store.dispatch('getPatientInfoAssurance', { patient_id: response.patient_id })
            this.display_all_loading = false;

            // Depot patient
            this.$store.dispatch('getDepotPatient', response.patient_id).then(() => {
                if (this.depot_patient.length == 0) {
                    this.can_pay_with_deposit = false
                } else {
                    this.can_pay_with_deposit = true
                }
            })

            if(response.operation_id > 0 && response.est_paye == 2) {
                this.is_consultation = true
                this.$store.dispatch('getAnOperation', response.operation_id).then(
                    (op_data) => {
                        this.prix_consult = op_data
                        this.carnets = op_data.enfants;

                        let base_assurance = (this.consult_back.prix_prestation > 0)?parseInt(this.consult_back.prix_prestation):0
                        // let part_assure = (this.consult_back.prix_assure > 0)?parseInt(this.consult_back.prix_assure):0

                        if (this.patient_est_assure == 1) {
                            if (parseInt(this.consult_back.prix) == 0) {
                                this.consultation_paye = parseInt(this.consult_back.tarif_consultation.prix) + parseInt(this.prix_carnet)
                            } else {
                                this.consultation_paye = parseInt(this.consult_back.prix) + parseInt(this.prix_carnet)
                            }

                            this.total_assureur.consultation = this.info_assurance['taux_consultation'] * base_assurance
                            this.total_assure.consultation = parseInt(op_data.montant) + parseInt(this.prix_carnet)
                        } else {
                            this.consultation_paye = parseInt(op_data.montant) + parseInt(this.prix_carnet)
                        }
                    }
                )
            }

            $('.p-content').fadeIn();
        });


        await this.$store.dispatch('getAnalysesForConsult', { consultation_id: this.passedConsult, bought: 2 }).then((response) => {
            this.total_analyse;
            // *** loop the response to get the cheboxes checked by default
            this.total_analyse_restant = 0;
            // let tot_base_assureur = 0
            // let tot_diff_prix = 0
            let total_assure_ananlyse = 0
            let total_assureur_analyse = 0
            response.forEach(element => {
                this.p_alys_assure[element.analyse.id] = 0
                if (!element.traite || element.traite == 0) {
                    this.analyse_checked.push(element)

                    this.total_analyse_restant += parseInt(element.analyse.prix)
                    if (this.patient_est_assure == 0) {
                        // this.total_analyse_restant += parseInt(element.analyse.prix)
                    } else {
                        // if (element.analyse.prix_base_assureur > 0) {
                        //     tot_base_assureur += parseInt(element.analyse.prix_base_assureur)
                        //     tot_diff_prix += parseInt(element.analyse.prix_additionnel)
                        // }
                        // this.total_analyse_restant += parseInt(element.analyse.base_assurance)
                        

                        if (element.analyse.est_exlusion == 0) {
                            if (element.analyse.prix_base_assureur > 0) {
                                total_assureur_analyse += (element.analyse.prix_base_assureur * this.info_assurance['taux_analyse'])
                                this.p_alys_assure[element.analyse.id] = ( ( 1 - this.info_assurance['taux_analyse'] ) * element.analyse.prix_base_assureur ) + element.analyse.prix_additionnel
                                total_assure_ananlyse += this.p_alys_assure[element.analyse.id]
                            } else {
                                total_assureur_analyse += 0 //(element.analyse.base_assurance * this.info_assurance['taux_analyse'])
                                this.p_alys_assure[element.analyse.id] = 0 //( ( 1 - this.info_assurance['taux_analyse'] ) * element.analyse.base_assurance )
                                total_assure_ananlyse += this.p_alys_assure[element.analyse.id]
                            }
                        } else {
                            total_assureur_analyse += 0
                            this.p_alys_assure[element.analyse.id] = element.analyse.base_assurance
                            total_assure_ananlyse += element.analyse.base_assurance
                        }
                        
                    }
                    this.is_analyse = true
                }
                
            });

            if (this.patient_est_assure == 1) {
                this.total_assureur.analyse = total_assureur_analyse
                this.total_assure.analyse = total_assure_ananlyse
            }

            // *** end loop the response to get the cheboxes checked by default

            if (this.total_analyse_restant == 0) {
                this.box3 = 0
            }
        })

        /**
         * Demande d'examens paracliniques
         */
        this.$store.dispatch('getConsultationExamen', { consultation_id: this.passedConsult, etat_paiement: 0 }).then(() => {
            if(this.demande_examen_consultation.length > 0) {
                this.has_examen = true
            } else {
                this.has_examen = false
            }

            let total_assure_examen = 0
            let total_assureur_examen = 0
            this.total_prix_examen = 0

            this.demande_examen_consultation.forEach(element => {
                this.p_exm_assure[element.type_examen_id] = 0
                this.examen_checked.push(element)

                this.total_prix_examen += parseInt(element.type_examen_prix)
                
                if (this.patient_est_assure == 0) {
                    // this.total_prix_examen += parseInt(element.type_examen_prix)
                } else {

                    // this.total_prix_examen += parseInt(element.base_assurance)

                    if (element.est_exlusion == 0) {
                        if (element.prix_base_assureur > 0) {
                            total_assureur_examen += (element.prix_base_assureur * this.info_assurance['taux_examen'])
                            this.p_exm_assure[element.type_examen_id] = ( ( ( 1 - this.info_assurance['taux_examen'] ) * element.prix_base_assureur ) + element.prix_additionnel )
                            total_assure_examen += this.p_exm_assure[element.type_examen_id]
                        } else {
                            total_assureur_examen += 0 //(element.base_assurance * this.info_assurance['taux_examen'])
                            this.p_exm_assure[element.type_examen_id] = 0 //( ( 1 - this.info_assurance['taux_examen'] ) * element.base_assurance )
                            total_assure_examen += this.p_exm_assure[element.type_examen_id]
                        }
                    } else {
                        total_assureur_examen += 0
                        this.p_exm_assure[element.type_examen_id] = element.base_assurance
                        total_assure_examen += element.base_assurance
                    }
                }
                this.is_examen = true
            });

            if (this.patient_est_assure == 1) {
                this.total_assureur.examen_para = total_assureur_examen
                this.total_assure.examen_para = total_assure_examen
            }
        })

        //recuperer les prescriptions
        this.$store.dispatch('getPrescriptionsPharmacie', { consultation_id: this.passedConsult, bought: 0 }).then(() => {

            let total_assure_medoc = 0
            let total_assureur_medoc = 0
            // enregistrer la liste des quantités et initialiser le checkbox correspondant
            this.prescription.forEach(data => {
                this.p_ord_assure[data.medicament_stock] = 0
                let qte = 0
                this.qte_medoc.push(data.quantite - data.quantite_achat);
                qte = data.quantite - data.quantite_achat
                this.prescription_checked.push(data)

                this.total_prix_medicaments += ( data.prix * qte )

                /**
                 * Récupérer la base assurance si patient est assuré
                 */
                if (this.patient_est_assure == 0) {
                    // this.total_prix_medicaments += ( data.prix * qte )
                } else {
                    // this.total_prix_medicaments += (data.base_assurance * qte)

                    if (data.est_exlusion == 0) {
                        if (data.prix_base_assureur > 0) {
                            total_assureur_medoc += Math.ceil(data.prix_base_assureur * qte * this.info_assurance['taux_consultation'])
                            this.p_ord_assure[data.medicament_stock] = Math.ceil( ( ( 1 - this.info_assurance['taux_consultation'] ) * data.prix_base_assureur ) + data.prix_additionnel )
                            total_assure_medoc += this.p_ord_assure[data.medicament_stock] * qte
                        } else {
                            total_assureur_medoc += 0 //(data.base_assurance * qte * this.info_assurance['taux_consultation'])
                            this.p_ord_assure[data.medicament_stock] = 0 //( ( 1 - this.info_assurance['taux_consultation'] ) * data.base_assurance )
                            total_assure_medoc += 0 //this.p_ord_assure[data.medicament_stock] * qte
                        }
                    } else {
                        total_assureur_medoc += 0
                        this.p_ord_assure[data.medicament_stock] = data.base_assurance
                        total_assure_medoc += ( data.base_assurance * qte )
                    }
                }
                this.is_ordonnance = true
            })

            if (this.patient_est_assure == 1) {
                this.total_assureur.ordonnance = total_assureur_medoc
                this.total_assure.ordonnance = total_assure_medoc
            }
        })

        //  >>>> Récupère les protocoles de soins
        this.refreshCAT()

    },
    methods: {
        applyCoupon(value) {
            if (value == 1) {
                // this.calc_prix_reduction = this.somme_encaisse
                this.calc_prix_reduction = this.base_coupon
                this.is_coupon = true
            } else {
                this.is_coupon = false
            }
        },

        calcReduction() {
            if (!this.checkMaxCoupon()) {   // Verifie la limite max du coupon appliquable
                this.calc_prix_reduction = this.base_coupon
                this.coupon_too_big = true
                return;
            }

            if (this.coupon != '' && parseInt(this.coupon) >= 0) {
                this.calc_prix_reduction = parseInt( (1 - parseInt(this.coupon) / 100) * this.base_coupon)
            } else {
                this.calc_prix_reduction = this.base_coupon
            }
        },

        appliquerCoupon() {
            this.somme_encaisse = this.calc_prix_reduction

            if (this.is_consultation_coupon) {
                this.somme_encaisse += parseInt(this.prix_carnet)
            }

            if (this.is_depot) {
                const solde_disponible = (this.depot_patient.a_depense == 0)?this.depot_patient.montant:this.depot_patient.montant_restant
                if (solde_disponible < this.somme_encaisse) {
                    this.deposit_is_less = true
                } else {
                    this.deposit_is_less = false
                }
            }
            

            this.applyCoupon(0)
        },

        /**
         * Contrôle le max de coupon appliquable
         */
        checkMaxCoupon() {
            let is_applicable = true
            if (this.coupon > 100) {
                is_applicable = false
            }
            return is_applicable
        },

        date_function: function() {
            let date = new Date()
                // let expiration_d = new Date()
                // expiration_d.setDate(date.getDate() + 15)

            let today_month = date.getMonth() + 1
                // let expir_month = expiration_d.getMonth() + 1

            this.today_date = date.getDate() + '/' + today_month + '/' + date.getFullYear()
                // this.expiration_date = expiration_d.getDate() + '/' + expir_month + '/' + expiration_d.getFullYear()

            this.ref_bon = date.getHours() + '' + date.getMinutes() + '' + date.getSeconds() + '/' + today_month + '/' + date.getDate()
        },

        formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        /**
         * Désactiver / activer un jour de conduite à tenir
         * @param {*} selector 
         */
        jChange(selector) {
            let j_deactivate = document.getElementById(selector);
            let set_param = {}

            if (j_deactivate.checked) {
                set_param = {
                    "jour_id": j_deactivate.value,
                    "etat": 0
                }
            } else {
                set_param = {
                    "jour_id": parseInt(j_deactivate.value),
                    "etat": 1
                }
            }
            this.$store.dispatch('deactiveJourCat', set_param).then(() => {
                this.refreshCAT()
            })
        },

        async refreshCAT() {
            await this.$store.dispatch('getSoinsEnCoursByConsultation', { consultation_id: this.passedConsult, soins_state: 0 }).then((response) => {
                this.soins = response[0]
                
                /**
                 * Détermine les parts d'assurance (Assureur et assuré)
                 */
                this.prix_injectables = 0
                this.total_assureur.protocoles = 0
                this.total_assure.protocoles = 0
                this.soins.injectables.forEach(p_injectable => {
                    this.p_assure[p_injectable.id] = 0
                    this.p_tot_assure[p_injectable.id] = 0
 
                    this.prix_injectables += parseInt(p_injectable.total)
                    if (this.patient_est_assure == 0) {  
                        this.total_assureur.protocoles += 0
                        this.total_assure.protocoles += ( p_injectable.total )
                    } else {
                        
                        /**
                         * Si le patient est assuré INAM l'on applique la base INAM
                         *   sinon l'on applique le % sur le prix clinique
                         */
                        if (p_injectable.est_exclu == 0) {
                            if (this.info_assurance['raison_sociale'] == 'INAM') {
                                
                                this.total_assureur.protocoles += Math.ceil( p_injectable.total_prestation * this.info_assurance['taux_consultation'] )
                                this.total_assure.protocoles += p_injectable.total_prix_assure
                            } else {
                                this.total_assureur.protocoles += Math.ceil( p_injectable.total * this.info_assurance['taux_consultation'] )
                                
                                this.p_assure[p_injectable.id] = Math.ceil((1 - this.info_assurance['taux_consultation']) * p_injectable.prix)
                                this.p_tot_assure[p_injectable.id] = Math.ceil((1 - this.info_assurance['taux_consultation']) * p_injectable.total)
                                this.total_assure.protocoles += this.p_tot_assure[p_injectable.id]
                            }
                        } else {
                            this.total_assureur.protocoles += 0
                            this.total_assure.protocoles += ( p_injectable.total )
                        }
                        
                    }
                    
                });

                let prix_actes = 0
                this.soins.actes.forEach(p_acte => {
                    prix_actes += parseInt(p_acte.total)
                    this.is_soins = true
                });

                let prix_consommable = 0
                this.soins.consommables.forEach(p_conso => {
                    prix_consommable += parseInt(p_conso.total)
                });

                let prix_admission = 0
                this.soins.admissions.forEach(p_hospi => {
                    prix_admission += parseInt(p_hospi.total)
                });

                this.total_assure.protocoles = ( this.total_assure.protocoles + prix_actes + prix_consommable + prix_admission )

                // ========      FIN  PART  ASSURANCE   =========

                this.$store.dispatch('getCatJourID', this.passedConsult).then(() => {
                    /**
                     * Vérifie le nombre de jour coché.. s'il ne reste qu'un seul jour coché
                     * rendre incliquable ce dernier
                     */
                    let jour_len = this.jourCats.length
                    let j = 0
                    for (let i = 0; i < jour_len; i++) {
                        let is_checked = $("#j" + i + ":checked").val() ? true : false
                        if (is_checked == true) {
                            j++
                        }
                    }
                    if (j == 1) {
                        for (let i = 0; i < jour_len; i++) {
                            let is_checked = $("#j" + i + ":checked").val() ? true : false
                            if (is_checked == true) {
                                document.getElementById("j" + i).disabled = true;
                            }
                        }
                    } else {
                        for (let i = 0; i < jour_len; i++) {
                            document.getElementById("j" + i).disabled = false;
                        }
                    }
                });
            });
        },

        updateAnalyseSelection() {
            let total_check = 0;
            // let tot_base_assureur = 0
            // let tot_diff_prix = 0
            let total_assure_ananlyse = 0
            let total_assureur_analyse = 0
            this.analyse_checked.forEach(data => {
                let prix_analyse = 0
                prix_analyse = parseInt(data.analyse.prix)
                total_check += prix_analyse;
                if (this.patient_est_assure == 0) {
                    // prix_analyse = parseInt(data.analyse.prix)
                    // total_check += prix_analyse;
                } else {
                    // if (data.analyse.prix_base_assureur > 0) {
                    //     tot_base_assureur += parseInt(data.analyse.prix_base_assureur)
                    //     tot_diff_prix += parseInt(data.analyse.prix_additionnel)
                    // }

                    // prix_analyse = parseInt(data.analyse.base_assurance)
                    // total_check += prix_analyse;

                    if (data.analyse.est_exlusion == 0) {
                        if (data.analyse.prix_base_assureur > 0) {
                            total_assureur_analyse += (data.analyse.prix_base_assureur * this.info_assurance['taux_analyse'])
                            total_assure_ananlyse += ( ( 1 - this.info_assurance['taux_analyse'] ) * data.analyse.prix_base_assureur ) + data.analyse.prix_additionnel
                        } else {
                            total_assureur_analyse += (data.analyse.base_assurance * this.info_assurance['taux_analyse'])
                            total_assure_ananlyse += ( ( 1 - this.info_assurance['taux_analyse'] ) * data.analyse.base_assurance )
                        }
                    } else {
                        total_assureur_analyse += 0
                        total_assure_ananlyse += data.analyse.base_assurance
                    }
                }
            })

            this.total_analyse_restant = total_check;

            if (this.patient_est_assure == 1) {
                this.total_assureur.analyse = total_assureur_analyse
                this.total_assure.analyse = total_assure_ananlyse
            }
            
        },

        updateExamenSelected() {
            // let total_check = 0;
            // let tot_base_assureur = 0
            // let tot_diff_prix = 0

            let total_assure_examen = 0
            let total_assureur_examen = 0
            this.total_prix_examen = 0

            this.examen_checked.forEach(data => {
                // let prix_examen = 0
                let base_assurance = 0
                // prix_examen = parseInt(data.type_examen_prix)
                base_assurance = parseInt(data.base_assurance)

                this.total_prix_examen += parseInt(data.type_examen_prix)

                if (this.patient_est_assure == 0) {
                    // total_check += prix_examen;
                } else {

                    // total_check += base_assurance;

                    if (data.est_exlusion == 0) {
                        if (data.prix_base_assureur > 0) {
                            total_assureur_examen += (data.prix_base_assureur * this.info_assurance['taux_examen'])
                            total_assure_examen += ( ( ( 1 - this.info_assurance['taux_examen'] ) * data.prix_base_assureur ) + data.prix_additionnel )
                        } else {
                            total_assureur_examen += 0 //(base_assurance * this.info_assurance['taux_examen'])
                            total_assure_examen += 0 //( ( 1 - this.info_assurance['taux_examen'] ) * base_assurance )
                        }
                    } else {
                        total_assureur_examen += 0
                        total_assure_examen += base_assurance
                    }
                }
            })

            // this.total_prix_examen = total_check;

            if (this.patient_est_assure == 1) {
                this.total_assureur.examen_para = total_assureur_examen
                this.total_assure.examen_para = total_assure_examen
            }
        },

        updatePrescriptionSelection() {

            let total_assureur_medoc = 0
            let total_assure_medoc = 0
            this.total_prix_medicaments = 0

            this.prescription_checked.forEach(data => {
                let qte = 0

                qte = data.quantite - data.quantite_achat
                this.total_prix_medicaments += ( data.prix * qte )
                if (this.patient_est_assure == 0) {
                    // this.total_prix_medicaments += ( data.prix * qte )
                } else {
                    // this.total_prix_medicaments += (data.base_assurance * qte)

                    if (data.est_exlusion == 0) {
                        if (data.prix_base_assureur > 0) {
                            total_assureur_medoc += (data.prix_base_assureur * qte * this.info_assurance['taux_consultation'])
                            total_assure_medoc += ( ( ( 1 - this.info_assurance['taux_consultation'] ) * data.prix_base_assureur ) + data.prix_additionnel ) * qte
                        } else {
                            total_assureur_medoc += 0 //(data.base_assurance * qte * this.info_assurance['taux_consultation'])
                            total_assure_medoc += 0 //( ( 1 - this.info_assurance['taux_consultation'] ) * data.base_assurance ) * qte
                        }
                    } else {
                        total_assureur_medoc += 0
                        total_assure_medoc += ( data.base_assurance * qte )
                    }
                }
                this.is_ordonnance = true
            })

            if (this.patient_est_assure == 1) {
                this.total_assureur.ordonnance = total_assureur_medoc
                this.total_assure.ordonnance = total_assure_medoc
            }
        },

        /**
         * Valider / Différer un paiement
         * @param {*} differe 
         * @param {*} confirm_selector 
         */
        submitValider(differe, confirm_selector) {
            this.save_loading = true;
            this.btn_disable = true
            let confirm = document.getElementById(confirm_selector);
            let err = 0;
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé avoir encaissé le montant
                $('.err-msg').fadeIn(500)
                err++;
                this.save_loading = false;
                this.btn_disable = false
            }

            // +++++++++      Si confirmer via le checkbox, on enregistre    ++++++++++
            if (err == 0) {

                switch (this.operation_selected) {
                    case 'consultation':
                        this.saveConsultation(differe)
                        break;
                    case "box1":
                        // consultation
                        break;

                    case "soins":
                        // Soins
                        this.saveSoinsDatas(differe)
                        break;

                    case "analyses":
                        // Analyse
                        this.saveAnalyseDatas(differe)
                        break;
                    case "prescri":
                        // Prescriptions de médicament
                        this.savePrescriptionsDatas(differe)
                        break;
                    case "examen_para":
                        // Examen paraclinique
                        this.saveExamenData(differe)
                        break;
                    default:
                        break;
                }
            }

        },

        /**
         * Payer/Différer une consultation
         * @param number est_paye 0 => Différé | 1 => Payé
         */
        saveConsultation(est_paye) {
            let facture_assur = []
            let assur_facture = {}

            if (this.patient_est_assure == 1) {
                assur_facture = {
                    patient_id: this.patient.id,
                    base_assurance: this.consultation.prix_prestation,
                    taux_couverture: parseFloat(this.info_assurance.taux_consultation),
                    part_assureur: this.total_paye_assureur,
                    part_assure: this.total_paye_assure,
                    prestation: this.consultation.tarif_consultation.type_consultation.nom+' ('+this.consultation.tarif_consultation.moment_consultation.denomination+')'
                }
                facture_assur.push(assur_facture)
            }

            let prix_consultation = 0

            let r_coupon = []
            let coupon_data = {}

            if (parseInt(this.coupon) > 0) {
                prix_consultation = (1 - this.coupon / 100 ) * parseInt(this.prix_consult.montant)

                coupon_data = {
                    user_id: this.user_id,
                    coupon: (parseInt(this.prix_consult.montant) - prix_consultation),
                    prix_clinique: parseInt(this.prix_consult.montant),
                    prestation: 'Bon de consultation',
                    compte_id: this.compte_id
                }
                r_coupon.push(coupon_data)
            }

            let d = {
                assurance_facture: facture_assur,
                consultation_id: this.consultation.id,
                operation_id: this.consultation.operation_id,
                est_paye: est_paye,
                est_assure: this.patient_est_assure,
                compte_id: this.compte_id,
                user_id: this.user_id,
                prix_consultation: prix_consultation,
                prix_prestation: this.somme_encaisse,
                coupon: r_coupon,
                utilisateur_id: this.patient.id,
                type_utilisateur: 1,
                categorie_operation_id: 1,
                depot_info: this.depot_info,
                is_with_deposit: this.can_pay_with_deposit
            }
        
            this.$store.dispatch('validatePendingConsultation', d).then((response) => {
                if (response > 0) {
                    $('.modal').modal('hide');
                    this.doAfterSuccess(est_paye)
                }

                if (this.can_apply_reliquat) {
                   this.$store.dispatch('storeReliquat', this.paiement) 
                }

                this.save_loading = false
            })
        },

        /**
         * Enregistrer le paiement issu d'une demande d'examen paraclinique
         * @param {*} comptabilise 
         */
        saveExamenData(comptabilise) {
            let len = this.examen_checked.length
            let i = 0

            this.examen_checked.forEach((examen_para) => {
                let facture_assur = []
                let assur_facture = {}

                let prix_comptabilise = 0 
                let p_assureur = 0
                let b_assureur = 0
                if (this.patient_est_assure == 1) {
                    if (examen_para.est_exlusion == 0) {
                        if (examen_para.prix_base_assureur > 0) {
                            b_assureur = examen_para.prix_base_assureur
                            p_assureur = examen_para.prix_base_assureur * this.info_assurance['taux_examen']
                            prix_comptabilise = ( ( 1 - this.info_assurance['taux_examen'] ) * examen_para.prix_base_assureur ) + examen_para.prix_additionnel
                        } else {
                            b_assureur = 0 //examen_para.base_assurance
                            p_assureur = 0 //examen_para.base_assurance * this.info_assurance['taux_examen']
                            prix_comptabilise = 0 //( ( 1 - this.info_assurance['taux_examen'] ) * examen_para.base_assurance )
                        }
                    } else {
                        p_assureur = 0
                        prix_comptabilise = examen_para.base_assurance
                    }
                } else {
                    prix_comptabilise = examen_para.type_examen_prix

                    if (this.coupon > 0) {
                        prix_comptabilise = (1 - this.coupon / 100 ) * examen_para.type_examen_prix
                    }
                }

                let prix_prestation = 0
                if (this.patient_est_assure == 0) {
                    prix_prestation = parseInt(examen_para.type_examen_prix)
                } else {
                    if (examen_para.prix_base_assureur > 0) {
                        prix_prestation = parseInt(examen_para.prix_base_assureur)
                    } 
                    // else {
                    //     prix_prestation = parseInt(examen_para.base_assurance)
                    // }
                }

                if (prix_prestation > 0) {
                    if (this.patient_est_assure > 0 && examen_para.est_exlusion == 0) {
                        assur_facture = {
                            patient_id: this.patient.id,
                            base_assurance: b_assureur,
                            taux_couverture: this.info_assurance['taux_examen'],
                            part_assureur: p_assureur,
                            part_assure: prix_comptabilise,
                            prestation: 'Examen - '+examen_para.type_examen_nom
                        }
                        facture_assur.push(assur_facture)
                    }

                    let r_coupon = []
                    let coupon_data = {}

                    if (parseInt(this.coupon) > 0) {
                        coupon_data = {
                            user_id: this.user_id,
                            coupon: (examen_para.type_examen_prix - prix_comptabilise),
                            prix_clinique: examen_para.type_examen_prix,
                            prestation: 'Examen - '+examen_para.type_examen_nom,
                            compte_id: this.compte_id
                        }
                        r_coupon.push(coupon_data)
                    }

                    let operation_data = {
                        libelle: 'Examen - '+examen_para.type_examen_nom,
                        montant: prix_comptabilise,
                        coupon: r_coupon,
                        type_operation: 1,
                        comptabilise: comptabilise,
                        user_id: this.user_id,
                        utilisateur_id: this.patient.id,
                        type_utilisateur: 1,
                        destination: this.compte_id,
                        categorie_operation_id: 2,
                        depot_info: this.depot_info,
                        is_with_deposit: this.can_pay_with_deposit
                    };

                    this.$store.dispatch("storeOperation", operation_data).then((response) => {
                        this.operation_saved = this.$store.getters['operation']
                            ////ON ENREGISTRE ALORS LE COMPTE OPERATION
                        let operation = response.id

                        // ON FAIT UN UPDATE DE L'analyse en question
                        let examen_to_send = [];
                        examen_to_send.push(examen_para)

                        let data = {
                            consultation_id: this.passedConsult,
                            operation_id: operation,
                            examen_checked: examen_to_send,
                            examen_selected_id: this.examen_to_pay_id,
                            est_paye: (comptabilise == true)?1:2,
                            prix_prestation: (this.patient_est_assure == 0)?examen_para.type_examen_prix:examen_para.base_assurance,
                            part_assure: prix_comptabilise,
                            est_assure: this.patient_est_assure,
                            assurance_facture: facture_assur,
                            coupon: r_coupon,
                        }

                        this.$store.dispatch("updateBulExamen", data)
                    })
                }
                i++

                if (i == len) {
                    $('.modal').modal('hide');
                    
                    if (this.can_apply_reliquat) {
                        this.$store.dispatch('storeReliquat', this.paiement)
                    }
                    
                    this.doAfterSuccess(comptabilise)
                    this.box3 = 0;
                    this.$forceUpdate();
                }
            })
            
        },

        saveAnalyseDatas(comptabilise) {
            let len = this.analyse_checked.length
            let i = 0

            // on parcour les analyses pour enregistrement
            this.analyse_checked.forEach((analyse) => {
                let facture_assur = []
                let assur_facture = {}

                let prix_comptabilise = 0 
                let p_assureur = 0
                let b_assureur = 0
                if (this.patient_est_assure == 1) {
                    if (analyse.analyse.est_exlusion == 0) {
                        if (analyse.analyse.prix_base_assureur > 0) {
                            b_assureur = analyse.analyse.prix_base_assureur
                            p_assureur = analyse.analyse.prix_base_assureur * this.info_assurance['taux_analyse']
                            prix_comptabilise = ( ( 1 - this.info_assurance['taux_analyse'] ) * analyse.analyse.prix_base_assureur ) + analyse.analyse.prix_additionnel
                        } else {
                            b_assureur = 0 //analyse.analyse.base_assurance
                            p_assureur = 0 //analyse.analyse.base_assurance * this.info_assurance['taux_analyse']
                            prix_comptabilise = 0 //( 1 - this.info_assurance['taux_analyse'] ) * analyse.analyse.base_assurance
                        }
                    } else {
                        p_assureur = 0
                        prix_comptabilise = analyse.analyse.base_assurance
                    }
                } else {
                    prix_comptabilise = analyse.analyse.prix

                    if (this.coupon > 0) {
                        prix_comptabilise = (1 - this.coupon / 100 ) * analyse.analyse.prix
                    }
                }
                
                let prix_prestation = 0
                if (this.patient_est_assure == 0) {
                    prix_prestation = parseInt(analyse.analyse.prix)
                } else {
                    if (analyse.analyse.prix_base_assureur > 0) {
                        prix_prestation = parseInt(analyse.analyse.prix_base_assureur)
                    }
                }

                if (prix_prestation > 0) {
                    if (this.patient_est_assure > 0 && analyse.analyse.est_exlusion == 0) {
                        assur_facture = {
                            patient_id: this.patient.id,
                            base_assurance: b_assureur,
                            taux_couverture: this.info_assurance['taux_analyse'],
                            part_assureur: p_assureur,
                            part_assure: prix_comptabilise,
                            prestation: 'Analyse'
                        }
    
                        facture_assur.push(assur_facture)
                    }

                    let r_coupon = []
                    let coupon_data = {}

                    if (parseInt(this.coupon) > 0) {
                        coupon_data = {
                            user_id: this.user_id,
                            coupon: (analyse.analyse.prix - prix_comptabilise),
                            prix_clinique: analyse.analyse.prix,
                            prestation: 'Analyse - '+analyse.analyse.nom,
                            compte_id: this.compte_id
                        }
                        r_coupon.push(coupon_data)
                    }

                    if (prix_comptabilise  > 0) {
                        let operation_data = {
                            libelle: 'Analyse - '+analyse.analyse.nom,
                            montant: prix_comptabilise,
                            coupon: r_coupon,
                            type_operation: 1,
                            comptabilise: comptabilise,
                            user_id: this.user_id,
                            utilisateur_id: this.patient.id,
                            type_utilisateur: 1,
                            destination: this.compte_id,
                            categorie_operation_id: 2,
                            depot_info: this.depot_info,
                            is_with_deposit: this.can_pay_with_deposit
                        };

                        this.$store.dispatch("storeOperation", operation_data).then((response) => {
                            this.operation_saved = this.$store.getters['operation']
                              
                            let operation = response.id

                            // ON FAIT UN UPDATE DE L'analyse en question
                            let analyse_to_send = [];
                            analyse_to_send.push(analyse)

                            let analyse_data = {
                                consult_id: this.passedConsult,
                                operation_id: operation,
                                analyses_checked: analyse_to_send,
                                analyse_selected_id: this.analyse_to_pay_id,
                                prix_prestation: (this.patient_est_assure == 0)?analyse.analyse.prix:analyse.analyse.base_assurance,
                                part_assure: prix_comptabilise,
                                est_differe: (comptabilise == 1)?0:1,       //  0 ==> Payé | 1 => Différé (VOIR dans cca_demande_analyse)
                                est_assure: this.patient_est_assure,
                                assurance_facture: facture_assur,
                                coupon: r_coupon,
                            }

                            this.$store.dispatch("updateBulAnalyse", analyse_data)
                        })
                    }
                }
                i++
                if (i == len) {
                    $('.modal').modal('hide');
                    if (comptabilise) {
                        if (this.can_apply_reliquat) {
                            this.$store.dispatch('storeReliquat', this.paiement) 
                        }
                       
                    }
                    
                    this.doAfterSuccess(comptabilise)
                    this.box3 = 0;
                    this.$forceUpdate();
                }
            })
            
        },

        saveSoinsDatas(comptabilise) {
            let facture_assur = []
            let assur_facture = {}

            if (this.patient_est_assure > 0) {
                let prix_comptabilise = 0 
                let p_assureur = 0

                p_assureur = this.total_assureur.protocoles
                prix_comptabilise = this.total_assure.protocoles

                assur_facture = {
                    patient_id: this.patient.id,
                    base_assurance: this.prix_injectables,
                    taux_couverture: this.info_assurance['taux_consultation'],
                    part_assureur: p_assureur,
                    part_assure: prix_comptabilise,
                    prestation: 'Protocoles de soins'
                }
                facture_assur.push(assur_facture)
            }

            // get articles to send to stock
            let articles = [];

            this.soins.consommables.forEach(element => {
                if (element.libelle && element.libelle != '') {
                    articles.push({ article: element.id, libelle: element.libelle, quantite: element.qte })
                }
            });
            this.soins.injectables.forEach(element => {
                if (element.libelle && element.libelle != '') {
                    articles.push({ article: element.id, libelle: element.libelle, quantite: element.qte })
                }
                
                // if (this.patient_est_assure == 0) {
                //     articles.push({ article: element.id, libelle: element.libelle, quantite: element.qte })
                // } else {
                //     if (this.info_assurance['raison_sociale'] == 'INAM') {
                //         if (element.total_prestation > 0) {
                //             articles.push({ article: element.id, libelle: element.libelle, quantite: element.qte })
                //         }
                //     }
                // }
            });

            let for_stock = {
                "patient": this.patient.nom + " " + this.patient.prenoms,
                "prescripteur": "interne",
                "articles": articles
            }
                //ON FAIT UN UPDATE EN STOCK DES PRODUITS
            this.$store.dispatch("postVenteSoinsEffectues", for_stock).then((response) => {

                if (response.reponse == false) {
                    this.doAfterErrorVente(response.erreur)
                } else {
                    let jour_checked = [];
                    $('input[name="jour_checked"]:checked').each(function() {
                        jour_checked.push(this.value)
                    });

                    let montant_comptabilise = 0

                    if (this.patient_est_assure == 1) {
                        montant_comptabilise = this.total_assure.protocoles
                    } else {
                        montant_comptabilise = this.total_soins

                        if (this.coupon > 0) {
                            montant_comptabilise = (1 - this.coupon / 100 ) * this.total_soins
                        }
                    }

                    let r_coupon = []
                    let coupon_data = {}

                    if (parseInt(this.coupon) > 0) {
                        coupon_data = {
                            user_id: this.user_id,
                            coupon: (this.total_soins - montant_comptabilise),
                            prix_clinique: this.total_soins,
                            prestation: 'Soins',
                            compte_id: this.compte_id
                        }
                        r_coupon.push(coupon_data)
                    }

                    let c_data = {
                        id_consult: this.passedConsult, 
                        operation: (comptabilise)?1:2, 
                        jours_selected: jour_checked,
                        est_assure: this.patient_est_assure,
                        assurance_facture: facture_assur,
                        coupon: r_coupon, 
                    }

                    if (comptabilise) {
                        let operation_data = {
                            libelle: 'Soins effectués',
                            montant: montant_comptabilise,
                            coupon: r_coupon,
                            type_operation: 1,
                            comptabilise: comptabilise,
                            user_id: this.user_id,
                            utilisateur_id: this.patient.id,
                            type_utilisateur: 1,
                            destination: this.compte_id,
                            categorie_operation_id: 4,
                            depot_info: this.depot_info,
                            is_with_deposit: this.can_pay_with_deposit
                        };
                        this.$store.dispatch("storeOperation", operation_data).then(() => {
                            // ON FAIT UN UPDATE COTE CLINIQUE
                            this.$store.dispatch("sendStateSoinsValider", c_data).then(() => {
                                this.doAfterSuccess(comptabilise)
                                this.box2 = 0;
                            })

                            if (this.can_apply_reliquat) {
                                this.$store.dispatch('storeReliquat', this.paiement)
                            }
                            
                        })

                    } else { // on ne comptabilise pas 
                        this.$store.dispatch("sendStateSoinsValider", c_data).then(() => {
                            this.doAfterSuccess(comptabilise)
                            this.box2 = 0;
                        })
                    }
                }
            })
        },
        savePrescriptionsDatas(comptabilise) {
            let articles = [];
            

            let prescriptions_to_return = [];
            let r_coupon = []
            let coupon_data = {}

            this.prescription_checked.forEach(data => {
                let index = this.prescription.indexOf(data);
                this.qte_medoc.push(data.quantite - data.quantite_achat);

                let prix_comptabilise = 0
                let p_assureur = 0
                let b_assureur = 0

                if (this.patient_est_assure == 1) {
                    if (data.est_exlusion == 0) {
                        if (data.prix_base_assureur > 0) {
                            b_assureur = data.prix_base_assureur 
                            p_assureur = b_assureur * this.info_assurance['taux_consultation'] * this.qte_medoc[index]
                            prix_comptabilise = ( ( 1 - this.info_assurance['taux_consultation'] ) * b_assureur ) + data.prix_additionnel
                            prix_comptabilise = prix_comptabilise * this.qte_medoc[index]
                        } else {
                            b_assureur = 0 //(data.base_assurance * this.qte_medoc[index])
                            p_assureur = 0 //b_assureur * this.info_assurance['taux_consultation']
                            prix_comptabilise = 0 //( ( 1 - this.info_assurance['taux_consultation'] ) * b_assureur )
                        }
                    } else {
                        p_assureur = 0
                        prix_comptabilise = data.base_assurance * this.qte_medoc[index]
                    }

                } else {
                    prix_comptabilise = data.prix * this.qte_medoc[index]

                    if (this.coupon > 0) {
                        prix_comptabilise = (1 - this.coupon / 100 ) * prix_comptabilise
                    }
                }

                let prix_prestation = 0
                if (this.patient_est_assure == 0) {
                    prix_prestation = data.prix * this.qte_medoc[index]
                } else {
                    if (data.prix_base_assureur > 0) {
                        prix_prestation = data.prix_base_assureur * this.qte_medoc[index]
                    }
                }
                
                if (prix_prestation > 0) {
                    articles.push({
                        article: data.medicament_stock,
                        libelle: data.medicament_libelle,
                        quantite: this.qte_medoc[index],
                        posologie: data.posologie
                    });

                    let facture_assur = []
                    let assur_facture = {}

                    if (this.patient_est_assure > 0 && data.est_exlusion == 0) {
                        assur_facture = {
                            patient_id: this.patient.id,
                            base_assurance: b_assureur,
                            taux_couverture: this.info_assurance['taux_consultation'],
                            part_assureur: p_assureur,
                            part_assure: prix_comptabilise,
                            prestation: 'Ordonnance - '+data.medicament_libelle
                        }
                        facture_assur.push(assur_facture)
                    }

                    if (parseInt(this.coupon) > 0) {
                        coupon_data = {
                            user_id: this.user_id,
                            coupon: (prix_prestation - prix_comptabilise),
                            prix_clinique: prix_prestation,
                            prestation: 'Ordonnance - '+data.medicament_libelle,
                            compte_id: this.compte_id
                        }
                        r_coupon.push(coupon_data)
                    }
                    
                    prescriptions_to_return.push({
                        id: data.id,
                        quantite_achat: this.qte_medoc[index],
                        quantite_differe: (comptabilise) ? 0 : this.qte_medoc[index],
                        prix_prestation: prix_prestation,
                        part_assure: prix_comptabilise,
                        est_differe: (comptabilise == true)?0:1,
                        est_assure: this.patient_est_assure,
                        assurance_facture: facture_assur
                    })
                }
            })

            // envoi en stock
            let for_stock = {
                "patient": this.patient.nom + " " + this.patient.prenoms,
                "prescripteur": "interne",
                "articles": articles
            }
            // //ON FAIT UN UPDATE EN STOCK DES PRODUITS

            this.$store.dispatch("postVenteSoinsEffectues", for_stock).then((response) => {
                if (response.reponse == false) {
                    this.doAfterErrorVente(response.erreur)

                } else {
                    if (comptabilise) {
                        let total_comptabilise = 0
                        if (this.patient_est_assure == 1) {
                            total_comptabilise = this.total_assure.ordonnance
                        } else {
                            if (this.coupon > 0) {
                                total_comptabilise = (1 - this.coupon / 100 ) * this.total_prix_medicaments
                            } else {
                                total_comptabilise = this.total_prix_medicaments
                            }
                        }
                        
                        let operation_data = {
                            libelle: 'Vente de médicaments',
                            montant: total_comptabilise,
                            coupon: r_coupon,
                            type_operation: 1,
                            comptabilise: comptabilise,
                            user_id: this.user_id,
                            utilisateur_id: this.patient.id,
                            type_utilisateur: 1,
                            destination: this.compte_id,
                            categorie_operation_id: 5,
                            depot_info: this.depot_info,
                            is_with_deposit: this.can_pay_with_deposit
                        };

                        this.$store.dispatch("storeOperation", operation_data).then(() => {
                            this.doAfterSuccess(comptabilise)

                            // ON FAIT UN UPDATE COTE CLINIQUE
                            this.$store.dispatch("sendPrescriptionsAfterVente", {
                                idConsult: this.passedConsult,
                                est_assure: this.patient_est_assure,
                                ventes: prescriptions_to_return,
                                coupon: r_coupon
                            })

                            if (this.can_apply_reliquat) {
                                this.$store.dispatch('storeReliquat', this.paiement)
                            }
                            
                        })

                    } else {
                        this.$store.dispatch("sendPrescriptionsAfterVente", {
                            idConsult: this.passedConsult,
                            est_assure: this.patient_est_assure,
                            ventes: prescriptions_to_return,
                            coupon: r_coupon,
                        }).then(() => {
                            this.doAfterSuccess(comptabilise);
                        })  
                    }  
                }
            })
        },
        doAfterSuccess(comptabilise) {
            $('.modal').modal('hide')
            if (comptabilise == false) {
                this.doSuccessMsg('Le paiement a été différé avec succès');
            } else {
                this.doSuccessMsg('Enregistrement et encaissement effectués');
            }
            this.save_loading = false;
            this.is_printable = true;
            this.is_savable = false;

            this.btn_disable = false
            this.$router.push({ path: '/consultations-all' })
            confirm.checked = false
        },

        doAfterErrorVente(error) {
            this.save_loading = false;
            this.btn_disable = false

            $('.modal').modal('hide')

            var message = ""
            error.forEach((element, index) => {
                if (index == error.length - 1) {
                    message = message + element.libelle

                } else {
                    message = message + element.libelle + " ,"
                }
            });


            this.$toasted.show('Certains articles sont indisponible :' + message, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })
        },

        doSuccessMsg: function(msg) {
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'success'
            })
        },
        doErrorMsg: function(msg) {
            let to_print = "Veuillez choisir tous les éléments nécessaires pour l'enregistrement";
            if (msg)
                to_print = msg

            if (this.$toasted != null) this.$toasted.clear()

            this.$toasted.show(to_print, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })
        },
        // controler la saisit des nombres de médicaments
        handleInput: function(value, index) {
            this.updateOrdonnance()

            if (parseInt(value) > 0) { //si c'est un entier saisit
                // si la quantité saisit dépasse la quantité restante à acheter
                // mettre la quantité réglémentaire
                let quantite_restante_a_acheter = parseInt(this.prescription[index].quantite) - parseInt(this.prescription[index].quantite_achat)

                if (value > quantite_restante_a_acheter) {
                    this.doErrorMsg("Quantité saisie incorrecte");
                    // this.qte_medoc[index] = quantite_restante_a_acheter
                    this.$set(this.qte_medoc, index, quantite_restante_a_acheter)
                }
            }
        },

        updateOrdonnance() {
            let total_assureur_medoc = 0
            let total_assure_medoc = 0
            this.total_prix_medicaments = 0

            let i = 0
            this.prescription_checked.forEach(data => {
                let qte = 0

                qte = this.qte_medoc[i]
                this.total_prix_medicaments += ( data.prix * qte )

                if (data.est_exlusion == 0) {
                    if (data.prix_base_assureur > 0) {
                        total_assureur_medoc += (data.prix_base_assureur * qte * this.info_assurance['taux_consultation'])
                        total_assure_medoc += ( ( ( 1 - this.info_assurance['taux_consultation'] ) * data.prix_base_assureur ) + data.prix_additionnel ) * qte
                    } else {
                        total_assureur_medoc += 0 //(data.base_assurance * qte * this.info_assurance['taux_consultation'])
                        total_assure_medoc += 0 //( ( 1 - this.info_assurance['taux_consultation'] ) * data.base_assurance ) * qte
                    }
                } else {
                    total_assureur_medoc += 0
                    total_assure_medoc += ( data.base_assurance * qte )
                }
                this.is_ordonnance = true
                i++
            })

            if (this.patient_est_assure == 1) {
                this.total_assureur.ordonnance = total_assureur_medoc
                this.total_assure.ordonnance = total_assure_medoc
            }
        },

        openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
            this.operation_selected = selector
        },
        closeModal(selector) {
            closeModal.closeModal(selector);
        },

        /**
         * Definit le type de facture à payer (Ex. Soin, Consultation...)
         * @param {*} type_facture 
         */
        setInvoiceType(type_facture, is_depot) {
            this.operation_selected = type_facture
            if (is_depot) {
                this.depot_info = this.depot_patient
                this.is_reliquat = false
            } else {
                this.is_reliquat = true
            }
            this.is_depot = is_depot
            this.deposit_is_less = false

            const solde_disponible = (this.depot_patient.a_depense == 0)?this.depot_patient.montant:this.depot_patient.montant_restant

            switch (type_facture) {
                case 'consultation':
                    this.somme_encaisse = (this.patient_est_assure == 0)?this.consultation_paye:this.total_assure.consultation
                    this.base_coupon = parseInt(this.prix_consult.montant)
                    this.is_consultation_coupon = true

                    
                    if (solde_disponible < this.somme_encaisse && is_depot) {
                        this.deposit_is_less = true
                    }
                    this.paiement.prestation = 'Bon de consultation'
                    this.paiement.categorie_operation_id = 1
                    break;
                case 'analyses':
                    // if (idSelected > 0) {
                    //     this.analyse_to_pay_id = idSelected
                    //     this.analyse_to_pay_montant = mtSelected
                    //     this.somme_encaisse = mtSelected
                    // } else {
                    //     this.somme_encaisse =   (this.patient_est_assure == 0)?this.total_analyse_restant:this.total_assure.analyse
                    //     this.analyse_to_pay_id = 0
                    //     this.analyse_to_pay_montant = 0

                    //     if (this.total_analyse_restant == 0) this.doErrorMsg('Veuillez sélectionner des analyses à payer')
                    // }

                    this.somme_encaisse =   (this.patient_est_assure == 0)?this.total_analyse_restant:this.total_assure.analyse
                    this.analyse_to_pay_id = 0
                    this.analyse_to_pay_montant = 0

                    if (this.total_analyse_restant == 0) this.doErrorMsg('Veuillez sélectionner des analyses à payer')

                    this.base_coupon = this.somme_encaisse
                    this.is_consultation_coupon = false

                    if (solde_disponible < this.somme_encaisse && is_depot) {
                        this.deposit_is_less = true
                    }
                    this.paiement.prestation = 'Analyse'
                    this.paiement.categorie_operation_id = 2
                    break;
                case 'soins':
                    this.somme_encaisse = (this.patient_est_assure == 0)?this.total_soins:this.total_assure.protocoles
                    this.base_coupon = this.somme_encaisse
                    this.is_consultation_coupon = false

                    if (solde_disponible < this.somme_encaisse) {
                        this.deposit_is_less = true
                    }
                    this.paiement.prestation = 'Soins'
                    this.paiement.categorie_operation_id = 4
                    break;

                case 'prescri':
                    this.somme_encaisse = this.total_soins
                    // if (idSelected >= 0) { // pour les paiements individuels
                    //     this.index_medicament_selected = idSelected
                    //     this.somme_encaisse = parseInt(this.qte_medoc[idSelected]) * parseInt(this.prescription[idSelected].prix)
                    // } else { // pour le paiement en total
                    //     this.index_medicament_selected = -1;
                    //     this.somme_encaisse = (this.patient_est_assure == 1 && this.total_assure.ordonnance > 0)?this.total_assure.ordonnance:this.total_prix_medicaments
                    // }
                    this.index_medicament_selected = -1;
                    this.somme_encaisse = parseInt((this.patient_est_assure == 1)?this.total_assure.ordonnance:this.total_prix_medicaments) 

                    this.base_coupon = this.somme_encaisse
                    this.is_consultation_coupon = false
                    if (this.total_prix_medicaments == 0) this.doErrorMsg('Veuillez sélectionner des médicaments à payer')

                    if (solde_disponible < this.somme_encaisse && is_depot) {
                        this.deposit_is_less = true
                    }
                    this.paiement.prestation = 'Prescriptions'
                    this.paiement.categorie_operation_id = 5
                    break;
                case 'examen_para':
                    // this.somme_encaisse = this.total_prix_examen
                    // if (idSelected >= 0) { // pour les paiements individuels
                    //     this.examen_to_pay_id = idSelected
                    //     this.examen_to_pay_montant = mtSelected
                    //     this.somme_encaisse = mtSelected
                    // } else { // pour le paiement en total
                    //     this.examen_to_pay_id = 0
                    //     this.examen_to_pay_montant = 0
                    //     this.somme_encaisse = (this.patient_est_assure == 0)?this.total_prix_examen:this.total_assure.examen_para
                    // }

                    this.examen_to_pay_id = 0
                    this.examen_to_pay_montant = 0
                    this.somme_encaisse = (this.patient_est_assure == 0)?this.total_prix_examen:this.total_assure.examen_para

                    this.base_coupon = this.somme_encaisse
                    this.is_consultation_coupon = false
                    if (this.total_prix_examen == 0) this.doErrorMsg('Veuillez sélectionner des examens à payer')

                    if (solde_disponible < this.somme_encaisse && is_depot) {
                        this.deposit_is_less = true
                    }
                    this.paiement.prestation = 'Examen'
                    this.paiement.categorie_operation_id = 3
                    break;

                default:
                    break;
            }
            
        },


        printFacture() {
            this.$refs.facture_html2Pdf.generatePdf()
        },

        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                // const totalPages = pdf.internal.getNumberOfPages()

                let foot_content = 'Généré(e) via l\'application Clinicaa';

                let la_caisse = 'La caisse';
                let lome_le = cca_config.VILLE+', le ' + this.date_facture;

                // LOME LE
                pdf.setTextColor(150)
                pdf.setFontSize(10)
                pdf.text(lome_le, (0.5), (pdf.internal.pageSize.getHeight() - 1))

                // LA CAISSE
                pdf.setTextColor(150)
                pdf.setFontSize(10)
                pdf.text(la_caisse, (7), (pdf.internal.pageSize.getHeight() - 1))

                // FOOTER
                pdf.setTextColor(150)
                pdf.setFontSize(8)
                pdf.text(foot_content, (3.333858), (pdf.internal.pageSize.getHeight() - 0.3))
            }).save()
        },

        onProgress(ev) {
            console.log(ev)
        },

        hasStartedGeneration() {

        },

        hasGenerated(ev) {
            console.log(ev)
        },

        calcReliquat() {
            if (this.paiement.montant_paye > 0) {
                if (this.paiement.montant_paye > this.somme_encaisse) {
                    // this.paiement.reliquat = 
                    this.paiement.reliquat_remis = parseInt(this.paiement.montant_paye - this.somme_encaisse) 
                } else {
                    this.paiement.reliquat = 0
                    this.paiement.reliquat_remis = 0
                }
            } else {
                this.paiement.reliquat = 0
                this.paiement.reliquat_remis = 0
            }
            this.espece_is_less = false
            this.reliquat_is_greater = false
            this.field_is_empty = false
        },

        calcResteReliquat() {
            this.paiement.reliquat_remis = parseInt(this.paiement.reliquat_remis)
            if (!Number.isInteger(this.paiement.reliquat_remis)) {
                this.paiement.reliquat_remis = ''
                return
            }

            if (this.paiement.reliquat_remis >= 0) {
                let r = this.paiement.montant_paye - this.somme_encaisse
                if (this.paiement.reliquat_remis <= r) {
                    this.paiement.reliquat = r - this.paiement.reliquat_remis
                } else {
                    this.paiement.reliquat = (this.paiement.montant_paye - this.somme_encaisse)
                }
            }
            this.espece_is_less = false
            this.reliquat_is_greater = false
            this.field_is_empty = false
        },

        postponeReliquat() {
            this.paiement.reliquat_remis = 0
            this.paiement.reliquat = this.paiement.reliquat = (this.paiement.montant_paye - this.somme_encaisse)
        },

        nextToConfirm(v) {
            this.paiement.montant_paye = parseInt(this.paiement.montant_paye)
            if (!Number.isInteger(this.paiement.montant_paye)) {
                this.field_is_empty = true
                this.paiement.montant_paye = 0
                return
            }

            if (this.paiement.montant_paye < this.somme_encaisse) {
                this.espece_is_less = true
                return
            }

            let reliquat_du = this.paiement.montant_paye - this.somme_encaisse
            if (this.paiement.reliquat_remis > reliquat_du) {
                this.reliquat_is_greater = true
                return
            }

            this.paiement.montant_du = this.somme_encaisse
            this.paiement.user_id = this.user_id
            this.paiement.patient_id = this.patient.id
            this.paiement.compte_id = this.compte_id
            

            this.is_reliquat = !v
            this.can_apply_reliquat = v
        },

    }
}